import styled from 'styled-components';
import Link from 'next/link';
import { media } from 'public/styles';
import { Body, FlexBox, Box, dsColors } from '@Backlot-Cars/archie';

export const SliderContainer = styled(Box).attrs({
	position: 'relative',
	width: '100%',
	height: '100%',
	minHeight: '600px',
	overflow: 'hidden',
})`
	.swiper {
		width: 100%;
		height: 100%;
	}

	.swiper-slide {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
	}

	.swiper-pagination {
		bottom: 100px !important;
		left: 75px !important;
		right: 75px !important;
		transform: none !important;
		width: calc(100% - 150px) !important;
		display: flex;
		justify-content: center;
		gap: 8px;
		z-index: 10;
	}

	.swiper-pagination-bullet {
		width: 15% !important;
		height: 8px !important;
		background: ${dsColors.colorSurface.brandSecondary} !important;
		opacity: 1 !important;
		border-radius: 2px !important;
		transition: all 0.3s ease !important;
		cursor: pointer;
		margin: 0 4px !important;
	}

	.swiper-pagination-bullet-active {
		background: ${dsColors.colorBrand.primary} !important;
		transform: none;
	}

	.swiper-button-next,
	.swiper-button-prev {
		width: 40px !important;
		height: 40px !important;
		color: ${dsColors.colorText.invert} !important;
		background: none !important;
		border-radius: 50% !important;
		transition: all 0.3s ease !important;
		opacity: 1 !important;
		visibility: visible !important;
		top: auto !important;
		bottom: 40px !important;
		margin-top: 0 !important;
		z-index: 10;
		display: flex !important;
		align-items: center !important;
		justify-content: center !important;

		.swiper-navigation-icon {
			width: 18px !important;
			height: 18px !important;
		}

		&:hover {
			background: ${dsColors.colorBrand.primary} !important;
			color: ${dsColors.colorText.invert} !important;
		}
	}

	.swiper-button-prev {
		left: calc(50% - 60px) !important;
	}

	.swiper-button-next {
		right: calc(50% - 60px) !important;
	}

	@media ${media.larger} {
		display: none;
	}
`;

export const SlideContent = styled(FlexBox).attrs({
	position: 'absolute',
	flexDirection: 'column',
	justifyContent: 'flex-end',
	alignItems: 'center',
	textAlign: 'center',
	maxWidth: '800px',
	padding: '140px 40px',
	color: 'invert',
	zIndex: 2,
})`
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	justify-self: center;

	@media ${media.greaterThanUltraWide} {
		padding: 185px 40px;
	}
`;

export const SlideBackground = styled(Box).attrs({
	position: 'absolute',
	zIndex: 1,
})`
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-image: url(${(props) => props.image});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
`;

export const StyledBody = styled(Body)`
	line-height: 160%;
`;

export const StyledLink = styled(Link)`
	color: ${dsColors.colorSurface.primary};
`;
